/**
 * Onboarding status API — aggregated completion flags for the sidebar checklist.
 */

import apiClient from './client';

export interface OnboardingStatusResponse {
  knowledge_assets_uploaded: boolean;
  demo_studio_recorded: boolean;
  interview_completed: boolean;
  simulations_run: boolean;
  agent_conversation_run: boolean;
  total_completed: number;
  total_steps: number;
  all_complete: boolean;
}

export async function getOnboardingStatus(
  organizationId: string
): Promise<OnboardingStatusResponse> {
  const response = await apiClient.get<OnboardingStatusResponse>(
    `/api/onboarding/organizations/${organizationId}/status`
  );

  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to fetch onboarding status');
  }

  return response.data;
}
